import { Stack } from '@mui/material';
import DigitalStudioSteps from './digitalStudioSteps';
import { useTranslation } from 'react-i18next';
import DigitalStudioImageGallery from './digitalStudioImageGallery';
import digitalStudioData from '../../assets/data/digitalStudio.json';
import { useEffect } from 'react';

const DigitalStudioUIUX = () => {
    const {t} = useTranslation();

    const steps = [
        {label: t('digitalStudio.ui/ux.steps.1.label'), description: t('digitalStudio.ui/ux.steps.1.description'), fill: 25},
        {label: t('digitalStudio.ui/ux.steps.2.label'), description: t('digitalStudio.ui/ux.steps.2.description'), fill: 50},
        {label: t('digitalStudio.ui/ux.steps.3.label'), description: t('digitalStudio.ui/ux.steps.3.description'), fill: 75},
        {label: t('digitalStudio.ui/ux.steps.4.label'), description: t('digitalStudio.ui/ux.steps.4.description'), fill: 100}
    ];

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <>
            <Stack
                direction='column'
                justifyContent='start'
                alignItems='center'
                width='100%'
            >
                <DigitalStudioSteps list={steps}/>

                <DigitalStudioImageGallery list={digitalStudioData['ui/ux']}/>
            </Stack>
        </>
    );
}

export default DigitalStudioUIUX;